var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue2-date-picker',{ref:"datePicker",class:{
    'forms-datepicker': true,
    'is-valid': _vm.state === true,
    'is-invalid': _vm.state === false,
    'fit-width': _vm.fitWidth,
  },attrs:{"type":"date","inline":_vm.inline,"default-value":_vm.openDate,"clearable":_vm.clearButton,"input-class":_vm.formControlClass,"disabled-date":_vm.disabledDatesFct,"disabled":_vm.disabled,"value":_vm.dateValue,"multiple":_vm.multiple,"lang":"fr"},on:{"input":_vm.emitInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }